import { render, staticRenderFns } from "./EntitySwitcher.vue?vue&type=template&id=2a8af438"
import script from "./EntitySwitcher.vue?vue&type=script&lang=ts"
export * from "./EntitySwitcher.vue?vue&type=script&lang=ts"
import style0 from "./EntitySwitcher.vue?vue&type=style&index=0&id=2a8af438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports